export default defineNuxtRouteMiddleware((to) => {
    // add uri and page type to global store
    const { pageType, uri, showHamburgerMenu } = storeToRefs(useGlobalStore())
    const { entry } = storeToRefs(useEntryStore())

    // reset hamburger menu open state when page changes
    showHamburgerMenu.value = false

    // reset entry on navigation
    entry.value = {}

    if (to.path === '/') {
        uri.value = '__home__'
    } else {
        // remove first / from uri
        uri.value = to.path.slice(1)
    }

    if (uri.value === '__home__') {
        pageType.value = 'home'
    } else {
        pageType.value = 'page'
    }
})